import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import ApiServices from "../../../../services/ApiServices";
import { EG_PAYMENT_STATUS } from "../../../../constants/api-constants";
import "./PaymentProcessing.css";
import { clearRenewalIds } from "../../../AddInsServices/ManageSubscriptiondetails";

const EGPaymentProcessing = () => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let intervalId = null;

    const redirectByType = (type, params, sessionId) => {
      if (type === "renewal") {
        // clear renewal ids from local storage to avoid confusion for next renewal
        clearRenewalIds();
        const enterpriseGroupId = params.get("enterpriseId");
        if (!enterpriseGroupId) {
          history.push("/enterprisegroup");
          return;
        }
        history.push(`/enterprisegroup/${enterpriseGroupId}/add-ins`);
      } else if (type === "adpay") {
        const addId = params.get("itemId");
        if (addId) {
          history.push(`/ad-payment-success/${addId}`);
        } else {
          history.push("/ad-payment-success");
        }
      } else if (sessionId) {
        history.push(`/eg-payment-success?session_id=${sessionId}`);
      } else {
        history.push("/success");
      }
    };

    const checkPaymentStatus = async () => {
      const params = new URLSearchParams(location.search);
      const sessionId = params.get("session_id");
      const type = params.get("type");

      // No sessionId received — fall back to a generic success screen.
      if (!sessionId) {
        console.warn(
          "No session_id found in URL parameters. Redirecting to generic success page.",
        );
        redirectByType(type, params, sessionId);
        return;
      }

      try {
        const response = await ApiServices.httpGet(
          `${EG_PAYMENT_STATUS}?sessionId=${sessionId}`,
        );

        if (response?.responseStatus?.isSuccess) {
          if (intervalId) clearInterval(intervalId);
          redirectByType(type, params, sessionId);
        } else {
          redirectByType(type, params, sessionId);
        }
      } catch (error) {
        console.error("Error checking payment status:", error);
        if (intervalId) clearInterval(intervalId);
        redirectByType(type, params, sessionId);
      }
    };
    checkPaymentStatus();
    intervalId = setInterval(() => {
      checkPaymentStatus();
    }, 5000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [history, location.search]);

  return (
    <div className="payment-processing-container eg-payment-processing-container">
      <div className="payment-processing-content eg-payment-processing-content">
        <CircularProgress
          size={80}
          thickness={4}
          style={{ color: "#00d9ff" }}
        />
        <h2>Processing Your Payment</h2>
        <p>Please wait while we confirm your payment...</p>
        <p className="processing-note">
          Do not close this window or press the back button
        </p>
      </div>
    </div>
  );
};

export default EGPaymentProcessing;
